<div>
  <app-widget-box>
    <p class="text-green-600">Popular Wallets</p>
    <div class="flex flex-wrap justify-center items-stretch gap-1 mx-auto">
      @for (wallet of wallets().popular; track $index) {
      <div class="w-52">
        <app-widget-option [value]="wallet" (click)="selectWallet(wallet)">
        </app-widget-option>
      </div>
      }
    </div>
    @if (wallets().other.length > 0) {
    <p class="text-green-600">Other Wallets</p>
    <div class="flex flex-wrap justify-center items-stretch gap-1 mx-auto">
      @for (wallet of wallets().other; track $index) {
      <div class="w-52">
        <app-widget-option [value]="wallet" (click)="selectWallet(wallet)">
        </app-widget-option>
      </div>
      }
    </div>
    }
  </app-widget-box>
</div>